import React, { useState } from 'react'
import LoginForm from '../../components/form/SignUp/LoginForm';
import OtpVerification from '../../components/form/SignUp/OtpVerification';
import CustomNavbar from './PublicNavbar';

export default function LoginPage() {
  
    return (
        <>

            <CustomNavbar />
           
                <div className="signup-page">
                    <div className="signup-form-container">
                        <LoginForm />
                    </div>

                </div> 
               
        </>
    )
}
